import { Component, OnInit,ElementRef,ViewChild,Inject,PLATFORM_ID } from '@angular/core';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { RootService } from 'src/app/shared/services/root.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { SkeletonService } from 'src/app/shared/services/skeleton.service';
import { isPlatformBrowser } from '@angular/common';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-brands-you-can-trust',
  templateUrl: './brands-you-can-trust.component.html',
  styleUrls: ['./brands-you-can-trust.component.scss']
})
export class BrandsYouCanTrustComponent implements OnInit {
  @ViewChild('cardElement') cardElement: ElementRef;
  @ViewChild('featureDiv') featureDivRef!: ElementRef;
  brandslist: any;
  isUserLoggedIn: boolean = false;
  showLoader: any = false;
  productLoaded: boolean = false;
  environment1 =environment.s3bucket.url;

  constructor(private ApiService: ApiService,private router: Router,public skeletonService: SkeletonService,
    private rootService: RootService,  private behaviorService : BehaviourSubjectService,@Inject(PLATFORM_ID) private platformId: Object,private cleverService: ClevertapService
    ) { }
  sub: Subscription = new Subscription();
  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1 };
  ngOnInit(): void {
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
    }));
    this.getBrandList()
  }
  customOptions2: OwlOptions = {
    center:true,
    autoWidth: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    margin: 14,
    navText: [
      `<img alt="left" src="${this.environment1}assets/images/c-arrow-left.svg"/>`,
      `<img alt="right" src="${this.environment1}assets/images/c-arrow-right.svg"/>`
    ],
    responsive: {
      0: {
        items: 1
      },
      576: {
        items: 1
      },
      768: {
        items: 1
      },
      992: {
        items: 1
      },
      1200: {
        items: 1
      },
      1400: {
        items: 1
      }
    },
    nav: true
  }
imageSlider = {
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  centerMode: true,
  centerPadding:50,
  variableWidth: true,
  infinite: true,
  cssEase: 'linear',
  touchMove: true,
  prevArrow:`<button class="slick-prev"><img alt="right" src="${this.environment1}assets/images/c-arrow-left.svg"></button>`,
  nextArrow:`<button class="slick-next"><img alt="right" src="${this.environment1}assets/images/c-arrow-right.svg"></button>`,
  asNavFor: '.thumbs',
  arrows: true,
};
descSlider = {
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.imagepreview',
  dots: false,
  autoplay: false,
  draggable: true,
  focusOnSelect: true,
  prevArrow: '.client-thumbnails .prev-arrow',
  nextArrow: '.client-thumbnails .next-arrow',
  vertical: false,
};
  getBrandList() {
    let data = {
      "is_home_brand": true,
    }
    this.showLoader = true
    try {
      this.sub.add(this.ApiService.getVehicleInfo2(data).subscribe(
        (res) => {
          this.showLoader = false
          this.productLoaded = true
          this.brandslist = res.data
        },
        () => {
          this.showLoader = false
          this.productLoaded = true
        }
      ))
    }
    catch(err){}
  }


  bookNow(sub_lob:any, lob:any, ppl:any,pl:any, id:any) {
    if(this.isUserLoggedIn){
      let sublob = sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks'? 'trucks' : (sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' :sub_lob.replace(/\s/g, "-")?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob.replace(/\s/g, '-')?.toLowerCase() + '/' + lob + '/' + ppl + '/' +pl.replace(/\s/g, '-')?.toLowerCase() + '/' + id]);
    }
    else{
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', this.router.url)
      }
      this.router.navigate(['/login/']);
    }
}

gotoProductDetail(sub_lob:any, lob:any, ppl:any,pl:any, id:any) {
    let sublob = sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks'? 'trucks' : (sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' :sub_lob.replace(/\s/g, "-")?.toLowerCase();
    this.router.navigate(['/product-details/' + sublob.replace(/\s/g, '-')?.toLowerCase() + '/' + lob + '/' + ppl + '/' +pl.replace(/\s/g, '-')?.toLowerCase() + '/' + id]);
}

clevertapPDP(productDetailsData){

     try {
      this.cleverService.
       onProductDetailsPageButtonClick("Product detail", productDetailsData["id"], productDetailsData["model"],productDetailsData['images'][0].image_url, "Top Navigation")
     }
     catch { }
    
   }


// ngAfterViewChecked() {
//   this.adjustScroll();
// }

isScrollable(): boolean {
  const featureDiv: HTMLElement = this.featureDivRef?.nativeElement;
  const textHeight = featureDiv?.scrollHeight;
  return textHeight && textHeight > 300;
}

// adjustScroll() {
//   const featureDiv: HTMLElement = this.featureDivRef?.nativeElement;
//   if (featureDiv) {
//     this.isScrollable(); // Call the isScrollable() method to apply the initial styles
//   }
// }

updateImageSize(imageUrl: string, element: HTMLElement, width?: number, height?: number): string {
  if (!isPlatformBrowser(this.platformId)) {
    return imageUrl;
  }

  if (!imageUrl) {
    console.log('Invalid image URL');
    return '';
  }

  if (!element) {
    console.log('Invalid Element');
    return imageUrl;
  }

  try {
    // Get actual width & height of the card
    const actualWidth = width && width > 0 ? width : element.clientWidth || 300;  // Default to 300 if no width
    const actualHeight = height && height > 0 ? height : element.clientHeight || 200;  // Default to 200 if no height
  
    console.log('Element dimensions:', {
      clientWidth: element.clientWidth,
      clientHeight: element.clientHeight,
      actualWidth,
      actualHeight
    });

    const imgWidth = Math.floor(actualWidth * 0.8);
    const imgHeight = Math.floor((imgWidth / 100) * 67);
  
    console.log('Calculated dimensions:', {
      imgWidth,
      imgHeight
    });

    // Ensure the URL is properly formatted
    const baseUrl = imageUrl.split('/resize/')[0];  // Get the base URL without resize parameters
    if (!baseUrl) {
      console.log('Could not parse base URL');
      return imageUrl;
    }

    const updatedUrl = `${baseUrl}/resize/${imgWidth}x${imgHeight}`;
  
    console.log('Image URLs:', {
      original: imageUrl,
      base: baseUrl,
      updated: updatedUrl
    });

    return updatedUrl;
  } catch (error) {
    console.error('Error in updateImageSize:', error);
    return imageUrl;  // Return original URL if there's an error
  }
}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
